"use client"

import { useState } from "react"
import Footer from '../Footer'
import { Link } from "react-router-dom"

const faqs = [
  {
    question: "What makes Panjshir emeralds different from other emeralds?",
    answer:
      "Our emeralds are sourced directly from the renowned mines in the Panjshir Valley of Afghanistan — a region celebrated for producing exceptionally vivid green stones. We focus on hand-selecting, cutting, and polishing each gem to bring out its natural brilliance and fire.",
  },
  {
    question: "Are your emeralds ethically sourced and certified?",
    answer:
      "Yes — we are committed to full transparency and responsible sourcing. Each gem is legally exported, and we can provide documentation upon request. Our supply chain is designed to ensure both integrity and traceability from mine to client.",
  },
  {
    question: "Do you sell rough stones, cut gems, or finished jewellery?",
    answer:
      "We offer a spectrum of options: from high-quality rough crystals for collectors and investors, to expertly cut emeralds ready for jewellery design. Whether you're a jeweller, investor or enthusiast, we cater to your needs.",
  },
  {
    question: "How can I verify the quality and authenticity of a stone I purchase?",
    answer:
      "For our premium stones, we can provide independent lab reports or gem-certificates. In addition, we document each piece's weight, clarity, origin and cut. If you wish, you can request additional verification or a video inspection prior to purchase.",
  },
  {
    question: "What payment and shipping methods do you accept?",
    answer:
      "We support secure international payments via bank transfer, credit card or escrow services (depending on your region). Shipping is handled via insured, trackable couriers. All shipments are packaged discreetly and comply with legal export requirements.",
  },
  {
    question: "What is your return or refund policy?",
    answer:
      'Because each piece is unique, returns are handled case by case. If there is a discrepancy in description or damage during transit, we will work with you to resolve it — either via exchange, refund or alternative arrangement. Please refer to our "Returns & Refunds" policy page for details.',
  },
  {
    question: "Can I visit your showroom or inspect the stones in person?",
    answer:
      "Absolutely. If you are in the Dubai region (or willing to travel), you may schedule a private viewing by appointment. For international clients we can also arrange live video inspections and secure previewing.",
  },
  {
    question: "I'm interested in investment-grade emeralds. What should I consider?",
    answer:
      "When selecting an investment gem, consider colour intensity, clarity, carat weight, cut quality and origin. Panjshir emeralds with intense green colour and excellent cut typically hold higher value. We are happy to guide you through the investment considerations.",
  },
  {
    question: "How often do you update your inventory or release new stones?",
    answer:
      "Our inventory is refreshed as new stones are sourced and cut. Because each gem is unique, many items are one-of-a-kind. We recommend joining our mailing list for exclusive access to new arrivals and early previews.",
  },
  {
    question: "How can I stay informed about your latest offerings, events or news?",
    answer:
      "You can subscribe to our newsletter on the website, follow us on our social channels, or contact us directly. We regularly share behind-the-scenes content, featured stones, industry insights and exclusive offers.",
  },
]

export default function FAQPage() {
  const [openItem, setOpenItem] = useState(null)

  const toggleItem = (index) => {
    setOpenItem(openItem === index ? null : index)
  }

  return (
    <main className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-3xl px-4 py-20 md:px-6 md:py-28">
        <div className="mb-14 text-center md:mb-20">
          <h2 className="mb-3 text-3xl font-light tracking-tight text-balance text-gray-900 md:text-4xl lg:text-5xl">
            Frequently Asked Questions
          </h2>
          <p className="text-pretty text-base text-gray-600 md:text-lg">
            Everything you need to know about Panjshir emeralds
          </p>
        </div>

        <div className="w-full space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="group border border-gray-200 bg-white backdrop-blur-sm px-5 py-1 rounded-xl transition-all duration-300 hover:border-teal-400 hover:bg-white hover:shadow-lg hover:shadow-teal-500/5 md:px-6"
            >
              <button
                onClick={() => toggleItem(index)}
                className="flex w-full items-center justify-between py-4 text-left text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors md:text-base"
              >
                <span className={openItem === index ? "text-teal-600" : ""}>{faq.question}</span>
                <svg
                  className={`h-5 w-5 shrink-0 transition-transform duration-300 ${
                    openItem === index ? "rotate-180 text-teal-600" : "text-gray-500"
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    className="text-green-700"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openItem === index ? "max-h-96 pb-4" : "max-h-0"
                }`}
              >
                <p className="text-sm leading-relaxed text-pretty text-gray-600 md:text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center md:mt-20">
          <p className="text-sm text-gray-600 md:text-base">
            Still have questions?{" "}
            <Link
              to={'/contactus'}
              className="font-medium text-teal-600 underline-offset-4 transition-colors hover:underline hover:text-teal-700"
            >
              Contact us
            </Link>
          </p>
        </div>
      </div>
      <Footer/>
    </main>
  )
}
